'use strict';

/**
 * Parse Type Error.
 *
 * Example: Schema.number().typeError(parseTypeError).
 */ function parseTypeError({ type }) {
    return `typeError.${type}`;
}

exports.parseTypeError = parseTypeError;
//# sourceMappingURL=parseTypeError.js.map
